<template>
  <div v-if="furnishData" class="flat-furnish-calc">
    <div class="flat-furnish-calc__inner">
      <d-tabs-slider v-if="furnishData.tabsTitles && furnishData.tabsTitles.length" :slides="furnishData.tabsTitles" is-furnish @changeSlide="changeTab"/>
      <template v-if="isLoading">
        <div class="flat-furnish-calc__body _skeleton">
          <div class="flat-furnish-calc__row _top">
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__content">
                <div class="flat-furnish-calc__title skeleton-field">

                </div>
                <div class="flat-furnish-calc__info">
                  <div class="flat-furnish-calc__item">
                    <div class="flat-furnish-calc__label skeleton-field"></div>
                    <div class="flat-furnish-calc__text skeleton-field"></div>
                  </div>
                  <div class="flat-furnish-calc__item">
                    <div class="flat-furnish-calc__label skeleton-field"></div>
                    <div class="flat-furnish-calc__text skeleton-field"></div>
                  </div>
                  <div class="flat-furnish-calc__item">
                    <div class="flat-furnish-calc__label skeleton-field"></div>
                    <div class="flat-furnish-calc__text skeleton-field"></div>
                  </div>
                  <div class="flat-furnish-calc__item">
                    <div class="flat-furnish-calc__label skeleton-field"></div>
                    <div class="flat-furnish-calc__text skeleton-field"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__title skeleton-field"></div>
              <div class="flat-furnish-calc__options">
                <div class="flat-furnish-calc__option">
                  <div class="flat-furnish-calc__checkbox skeleton-field"></div>
                  <div class="flat-furnish-calc__checkbox-label skeleton-field"></div>
                </div>
                <div class="flat-furnish-calc__option">
                  <div class="flat-furnish-calc__checkbox skeleton-field"></div>
                  <div class="flat-furnish-calc__checkbox-label skeleton-field"></div>
                </div>
                <div class="flat-furnish-calc__option">
                  <div class="flat-furnish-calc__checkbox skeleton-field"></div>
                  <div class="flat-furnish-calc__checkbox-label skeleton-field"></div>
                </div>
                <div class="flat-furnish-calc__option">
                  <div class="flat-furnish-calc__checkbox skeleton-field"></div>
                  <div class="flat-furnish-calc__checkbox-label skeleton-field"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="flat-furnish-calc__row _bottom">
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__price-wrap">
                <div class="flat-furnish-calc__price">
                  <div class="flat-furnish-calc__label _bottom skeleton-field"></div>
                  <div class="flat-furnish-calc__price-value skeleton-field"></div>
                </div>
                <div class="flat-furnish-calc__price _opts">
                  <div class="flat-furnish-calc__label _bottom skeleton-field"></div>
                  <div class="flat-furnish-calc__price-value skeleton-field"></div>
                </div>
              </div>
            </div>
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__actions">
                <div class="flat-furnish-calc__action skeleton-field"></div>
                <div class="flat-furnish-calc__action skeleton-field"></div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="flat-furnish-calc__body">
          <div v-if="tabDataContent" class="flat-furnish-calc__row _top">
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__content">
                <div class="flat-furnish-calc__title">{{ tabDataContent.title }}</div>
                <div v-if="tabDataContent.data && tabDataContent.data.length" class="flat-furnish-calc__info">
                  <div v-for="option in tabDataContent.data" :key="option.label" class="flat-furnish-calc__item" :class="{ _label: option.label}" >
                    <div v-if="option.label" class="flat-furnish-calc__label">{{ option.label }} <span v-if="option.items && option.items.length">*</span></div>
                    <div class="flat-furnish-calc__text-wrap _sub-main">
                      <div class="flat-furnish-calc__text" v-html="option.text"></div>
                      <div v-if="option.items" class="flat-furnish-calc__main-options">
                        <div v-for="childOption in option.items" :key="childOption.id" class="flat-furnish-calc__sub-option">
                          <d-input-radio
                              :name="childOption.id"
                              :id="`main-option-${childOption.id}`"
                              type="radio"
                              :value="childOption.id"
                              class=""
                              :error="errorOptionsId.includes(option.id)"
                              :model-value="checkChildOption(option, childOption)"
                              @update:modelValue="addToSelectedOptions(childOption, option)"
                          >
                            {{ childOption.label }}
                          </d-input-radio>
                          <button v-if="childOption.images && childOption.images.length" class="flat-furnish-calc__eye _sub-main" @click="openImagesPopup(childOption)">
                            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                              <use xlink:href="/assets/blueant/assets/sprite.svg#sprite-eye_furnish"></use>
                            </svg>
                          </button>
                        </div>

                      </div>
                      <div v-if="errorOptionsId.includes(option.id)" class="flat-furnish-calc__input-error _main">Выберите обязательную опцию</div>
                      <button v-if="option.images && option.images.length" class="flat-furnish-calc__eye _left" @click="openImagesPopup(option)">
                        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <use xlink:href="/assets/blueant/assets/sprite.svg#sprite-eye_furnish"></use>
                        </svg>
                      </button>
                    </div>

                  </div>
                </div>
              </div>

            </div>
            <div v-if="tabDataOptions.data" class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__title">{{ tabDataOptions.title }}</div>
              <div v-if="tabDataOptions.data.length" class="flat-furnish-calc__options">
                <div v-for="(option, idx) in tabDataOptions.data" :key="option.label" class="flat-furnish-calc__option">
                  <div class="d-checkbox">
                    <input class="d-checkbox__input" type="checkbox" :checked="checkOptionID(option)" name="option" :id="`option-${option.id}`" :value="option" @change="changeParentOption($event, option)">
                    <label class="d-checkbox__label" :for="`option-${option.id}`">{{ option.label }}</label>
                    <div v-if="option.items" class="flat-furnish-calc__sub-options">
                      <div class="flat-furnish-calc__sub-option" v-for="childOption in option.items" :key="childOption.id">
                        <d-input-radio
                            :name="option.id"
                            :id="`sub-option-${childOption.id}`"
                            type="radio"
                            :value="childOption.id"
                            class=""
                            :error="errorOptionsId.includes(option.id)"
                            :model-value="checkChildOption(option, childOption)"
                            @update:modelValue="addToSelectedOptions(childOption, option)"
                        >
                          {{ childOption.label }}
                        </d-input-radio>
                        <button v-if="childOption.images && childOption.images.length" class="flat-furnish-calc__eye _sub-other" @click="openImagesPopup(childOption)">
                          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                            <use xlink:href="/assets/blueant/assets/sprite.svg#sprite-eye_furnish"></use>
                          </svg>
                        </button>
                      </div>

                    </div>
                  </div>
                  <div v-if="errorOptionsId.includes(option.id)" class="flat-furnish-calc__input-error">Выберите обязательную опцию</div>
                  <button v-if="option.images && option.images.length" class="flat-furnish-calc__eye" @click="openImagesPopup(option)">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <use xlink:href="/assets/blueant/assets/sprite.svg#sprite-eye_furnish"></use>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="flat-furnish-calc__row _bottom">
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__price-wrap">
                <div class="flat-furnish-calc__price">
                  <div class="flat-furnish-calc__label _bottom">стоимость с отделкой</div>
                  <div class="flat-furnish-calc__price-value" v-if="furnishData.tabData?.price_request">{{ furnishData.tabData?.price_request_label }}</div>
                  <div class="flat-furnish-calc__price-value" v-else>{{ priceFormat }} ₽</div>
                </div>
                <div class="flat-furnish-calc__price _opts">
                  <div class="flat-furnish-calc__label _bottom">стоимость с выбранными опциями</div>
                  <div class="flat-furnish-calc__price-value" v-if="furnishData.tabData?.price_request">{{ furnishData.tabData?.price_request_label }}</div>
                  <div class="flat-furnish-calc__price-value" v-else>{{ priceWithOptions.toLocaleString('ru-RU') }} ₽</div>
                </div>
              </div>
            </div>
            <div class="flat-furnish-calc__col">
              <div class="flat-furnish-calc__actions">
                <a v-if="(!('can_booking' in dataFlat) || dataFlat.can_booking !== false) && dataBookingUrl" class="d-flat-top__button d-button _dark" :href="`${dataBookingUrl}`" @click.prevent="bookOnline" target="_blank"><span>Забронировать онлайн</span></a>
                <button class="d-flat-top__button d-button _blue" data-callMe-show :data-action-url="dataActionUrl" :data-lead-url="dataLeadUrl" :data-props="flatLeadData" ><span>Оставить заявку</span></button>
              </div>
              <div v-if="errorOptionsId.length" class="flat-furnish-calc__error">Выберите обязательную опцию</div>
            </div>

          </div>
        </div>
      </template>


    </div>

    <d-popup-simple v-model="showImagesPopup" @closed="closeImagesPopup" :with-close="false">
      <d-object-gallery-popup v-if="imagesPopupData" :photos="imagesPopupData" @close="closeImagesPopup" type="furnish"/>
    </d-popup-simple>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import DPopupSimple from "../molecules/DPopupSimple.vue";
import DObjectGalleryPopup from "../molecules/DObjectGalleryPopup.vue";
import DCheckbox from "@components/atoms/DCheckbox.vue";
import DInputRadio from "@components/atoms/DInputRadio.vue";
import DTabsSlider from "@components/molecules/DTabsSlider.vue";
import {useFlatStore} from '@/stores/flat';
import {mapState} from 'pinia';

export default {
  name: "DFlatFurnishCalc",
  components: {
    DInputRadio,
    DCheckbox,
    DPopupSimple,
    DObjectGalleryPopup,
    DTabsSlider
  },
  props: {
    dataApiUrl: String,
    dataApiSendParams: String,
    dataBookingUrl: String,
    dataActionUrl: {
      type: String,
      default: '',
    },
    dataLeadUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      furnishData: null,
      dataFlat: null,
      flatId: null,
      flatLeadData: '',
      selectedOptions: [],
      imagesPopupData: null,
      showImagesPopup: false,
      amount: 1,
      optionsAmount: [],
      priceWithOptions: 0,
      currentTab: 0,
      currentTabId: null,
      errorOptionsId: [],
      formInvalid: false,
      fakeTitles: ['Яркая эффектная архитектура', 'Яркая эффектная архитектура 2', 'Яркая эффектная архитектур 3', 'Яркая эффектная архитектура 4', 'Яркая эффектная архитектура 5'],
      currentIndexTab: 0,
      swiper: null,
      mainOptionsSelected: [],
      isLoading: true,
      isFetching: false
    }
  },
  watch: {
    optionsAmount: {
      handler: function () {
        this.priceWithOptionsCalculate()
      },
      deep: true
    },
    selectedOptions: {
      handler: function () {
        this.priceWithOptionsCalculate()
      },
      deep: true
    },
    isFetching(val) {
      if (val) {
        const furnishLoader = document.querySelector('#furnish-preloader')
        if (furnishLoader) furnishLoader.classList.add('_hide')

      }
    }
  },
  created() {
    this.getData()

    if (window.flat_info) {
      if (window.flat_data) this.dataFlat = Object.freeze(Object.assign({}, window.flat_info, window.flat_data));
      else this.dataFlat = Object.freeze(window.flat_info);
    }
    if (window.flat_id) {
      this.flatId = window.flat_id;
    }

    if (window.flat_id)  this.flatId = window.flat_id;
  },
  mounted() {
    const flatLeadData = {
      'area': this.dataFlat.area,
      'comment': '',
      'email': '',
      'flat': window.flat_id,
      'floor': this.dataFlat.floor,
      'formType': 'reserve',
      'housing': this.dataFlat.korpus,
      'price': this.dataFlat.price,
      'section': this.dataFlat.section,
      'sourceConversion': '',
      'typeFlat': this.dataFlat.rooms,
      'URL': window.location.href || '',
      'utm': Cookies.get('utm_data') || window.utm_str_src || '',
    };
    this.flatLeadData = JSON.stringify(flatLeadData);
  },
  computed: {
    priceFormat() {
      if (this.price) return Math.round(Number(this.price)).toLocaleString('ru-RU')
    },
    tabDataContent() {
      if (!this.furnishData) return null
      return this.furnishData.tabData.content
    },
    tabDataOptions() {
      if (!this.furnishData) return null
      return this.furnishData.tabData.options
    },
    ...mapState(useFlatStore, [
      'price',
    ]),
  },
  methods: {
    async getData() {
      this.isLoading = true
      try {
        const { data } = await this.axios.get(this.dataApiUrl, {
          params: {
            tabIndex: this.currentTab
          }
        });
        this.furnishData = data
        this.currentTabId = data.tabsTitles[this.currentTab].id
        console.log('response furnish', data)

        this.priceWithOptionsCalculate()

        const store = useFlatStore()
        store.price = Math.round(data?.tabData?.price)

      } catch (error) {
        console.error(error);
      }
      finally {
        this.isLoading = false
        this.isFetching = true
      }
    },

    getFurnish(tab, index) {
      this.currentTab = index
      this.currentTabId = tab.id
      this.getData()
    },
    bookOnline(e) {
      try {
        dataLayerPush('event_to_GA', 'button_click', 'buy_book_online');
      } catch (e) {
        console.error('%cDFlatInfo bookOnline() error to call dataLayerPush', 'color: yellow', e);
      }
      if (window.DonStroyWidget && window.flat_id) DonStroyWidget.prototype.openBookingPopup(window.flat_id, {textBookingObject: 'квартира'});
      else {
        console.error('%cDFlatInfo bookOnline() error to call DonStroyWidget', 'color: yellow', window.DonStroyWidget, window.flat_id);
        // window.open(this.dataBookingUrl ? `${this.dataBookingUrl}${this.furnishUrl}` : `/lk/forms/?object_id=${this.flatId}${this.furnishUrl}`);
        this.sendFurnishParams()
      }
      // this.sendFurnishParams()
    },
    async sendFurnishParams() {
      try {
        this.addOptionsIdToErrors()
        if (this.formInvalid) {
          console.log('form is not valid')
          return
        }
        const { renovation_type_id } = this.furnishData?.tabData
        const optionsDataForSend = []
        this.selectedOptions.forEach(item => {
          if (item.childOption) {
            optionsDataForSend.push(item.childOption.id)
          } else {
            optionsDataForSend.push(item.parentOption.id)
          }
        })

        const { data } = await this.axios.post(this.dataApiSendParams, {
          furnish_id: this.currentTabId,
          flat_id: this.flatId,
          price: this.priceWithOptions,
          options: optionsDataForSend,
          renovation_type_id
        })

        if (data.id) {
          window.location = (this.dataBookingUrl ? `${this.dataBookingUrl}&furnish_options_id=${data.id}` : `/lk/forms/?object_id=${this.flatId}&furnish_options_id=${data.id}`);
        }

        // console.log('resp furnish', data)
      } catch (e) {
        console.log(e)
      }
    },
    openImagesPopup(option) {
      this.showImagesPopup = true;
      this.imagesPopupData = option.images
    },
    closeImagesPopup() {
      this.showImagesPopup = false;
      this.imagesPopupData = null
    },
    priceWithOptionsCalculate() {
      if (!this.selectedOptions.length) this.priceWithOptions = Math.round(Number(this.furnishData?.tabData?.price))
      else {
        this.priceWithOptions = this.selectedOptions.reduce((acc, current, idx) => {
          const childValue = current.childOption?.value ? current.childOption.value : 0
          const parentValue = current.parentOption.value ? current.parentOption.value : 0
          return acc + childValue + parentValue
        }, Math.round(Number(this.furnishData?.tabData?.price)))
      }
    },
    changeParentOption(e, option) {
      const isChecked = e.target.checked
      if (isChecked) {
        if (!this.hasInArrayById(option.id, this.selectedOptions)) {
          this.selectedOptions.push({
            parentOption: option,
            childOption: null,
            childRequired: Boolean(option.items)
          })
        }
      } else {
        this.selectedOptions = this.selectedOptions.filter(item => item.parentOption.id !== option.id)
      }
    },
    addToSelectedOptions(option, parentOption) {
      if (parentOption) {
        if (this.hasInArrayById(parentOption.id, this.selectedOptions)) {
          this.selectedOptions = this.selectedOptions.filter(item => item.parentOption.id !== parentOption.id)
        }
        this.selectedOptions.push({
          parentOption: parentOption,
          childOption: option,
          childRequired: true
        })
      }
      this.errorOptionsId = this.errorOptionsId.filter(item => item !== parentOption.id)
    },
    hasInArrayById(elementID, array) {
      return array.find((item) => item.parentOption.id === elementID)
    },
    checkOptionID(option) {
      return this.selectedOptions.find(item => item.parentOption.id === option.id)
    },
    checkChildOption(parentOption, childOption) {
      if (!this.selectedOptions.length) return false
      const selectedParentOption = this.selectedOptions.find(item => item.parentOption.id === parentOption.id)

      if (selectedParentOption && selectedParentOption.childOption) {
        return selectedParentOption.childOption.id === childOption.id
      }
      return false
    },
    checkMainOption(parentOption, childOption) {
      if (!this.selectedOptions.length) return false
      const selectedParentOption = this.selectedOptions.find(item => item.parentOption.id === parentOption.id)

      if (selectedParentOption && selectedParentOption.childOption) {
        return selectedParentOption.childOption.id === childOption.id
      }
      return false
    },
    addOptionsIdToErrors() {
      const optionsWithChild = this.selectedOptions.filter(item => item.childRequired);
      this.errorOptionsId = []

      this.setRequiredOptions()
      optionsWithChild.forEach(item => {
        if (!item.childOption && !this.errorOptionsId.includes(item.parentOption.id)) {
          this.errorOptionsId.push(item.parentOption.id)
        }
      })
      this.formInvalid = Boolean(this.errorOptionsId.length)
    },



    setRequiredOptions() {
      if (!this.tabDataContent) return
      this.tabDataContent.data.forEach(option => {
        if (option.items) {
          if (!this.selectedOptions.length) {
            this.errorOptionsId.push(option.id)
          } else {
            const selectedRequiredOption = this.selectedOptions.find(item => item.parentOption.id === option.id)
            if (selectedRequiredOption) {
              this.errorOptionsId = this.errorOptionsId.filter(item => item.id !== option.id)
            } else {
              this.errorOptionsId.push(option.id)
            }
          }

        }
      })
    },
    changeTab({ tab, index}) {
      this.resetTab()
      this.getFurnish(tab, index)
    },
    resetTab() {
      this.selectedOptions = []
      this.errorOptionsId = []
    }
  }
}
</script>

<style scoped>

</style>